var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import localforage from "localforage";
const storage = localforage.createInstance({ name: "FlaVR", storeName: "webcam_backgrounds" });
const allowedTypes = new Set(["image/png", "image/jpeg", "image/webp"]);
export function listWebcamBackgrounds() {
    return __awaiter(this, void 0, void 0, function* () {
        const images = [];
        yield storage.iterate((image) => {
            images.push(image);
            return undefined;
        });
        return images.sort((left, right) => left.name.localeCompare(right.name));
    });
}
export function getWebcamBackground(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const image = yield storage.getItem(id);
        if (image === null)
            throw new Error("The selected webcam background is no longer stored in this browser");
        return image;
    });
}
export function saveWebcamBackground(file) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!allowedTypes.has(file.type))
            throw new Error("Please select a PNG, JPEG or WebP image");
        if (file.size > 10 * 1024 * 1024)
            throw new Error("Background images must not exceed 10 MB");
        const bitmap = yield createImageBitmap(file);
        try {
            if (bitmap.width > 4096 || bitmap.height > 4096)
                throw new Error("Background images must not exceed 4096 x 4096 pixels");
        }
        finally {
            bitmap.close();
        }
        const image = { id: crypto.randomUUID(), name: file.name, blob: file };
        yield storage.setItem(image.id, image);
        return image;
    });
}
export function removeWebcamBackground(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield storage.removeItem(id);
    });
}
